var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRediseo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#006E54;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21,
    cy: 21,
    r: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.2,17.873H19.384V8.055a.755.755,0,0,0-1.51,0v9.818H8.055a.755.755,0,0,0,0,1.51h9.818V29.2a.755.755,0,0,0,1.51,0V19.384H29.2a.755.755,0,0,0,0-1.51Z",
    transform: "translate(2.205 2.205)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRediseo);
export default __webpack_public_path__ + "static/media/rediseño.ac3ccd559c431b1cf0a1ee34643c395b.svg";
export { ForwardRef as ReactComponent };